import premiumIcon from "@assets/header/menu-selected/icon/premium-latest.svg";
import registeredUser from "@assets/header/menu-selected/icon/registered-user-new.svg";
import { useAccessPremiumLabel } from "@elements/ArticleParagraph/hooks/useAccessPremiumLabel";
import { LabelCardIconVariety } from "@elements/Icon/LabelCardIcon";
import { twMerge } from "tailwind-merge";

type ContainerProp = {
  label: string;
  icon: string;
  textColor: string;
  className?: string;
  showIcon?: boolean;
};

const Container = ({
  label,
  icon,
  textColor,
  className,
  showIcon,
}: ContainerProp) => (
  <span
    data-testid={`container-${label}`}
    className={twMerge(
      `flex max-w-max h-fit gap-x-1 items-center flex-nowrap`,
      textColor,
      className,
    )}
  >
    {showIcon && (
      <img data-testid={`icon-${label}`} src={icon} alt={label} width={16} />
    )}
    <span data-testid={label} className="font-primary text-xxs font-bold">
      {label}
    </span>
  </span>
);

export default function ContentAccessLabel({
  contentAccess,
  className,
  showIcon,
}: {
  contentAccess?: LabelCardIconVariety;
  className?: string;
  showIcon?: boolean;
}) {
  const { showPremiumLabel } = useAccessPremiumLabel(contentAccess);

  switch (contentAccess) {
    case LabelCardIconVariety.FREE:
      return null;
    case LabelCardIconVariety.PREMIUM:
      if (!showPremiumLabel) return null;
      return (
        <Container
          label="Bagi Pelanggan Sahaja"
          icon={premiumIcon}
          textColor="text-grey-940"
          className={className}
          showIcon={true}
        />
      );
    case LabelCardIconVariety.REGISTERED_USER:
      return (
        <Container
          label="Pengguna Berdaftar"
          icon={registeredUser}
          textColor="text-violet-200"
          className={className}
          showIcon={showIcon}
        />
      );
    default:
      return null;
  }
}
